/**
 * Product review blocks: category tabs and Swiper per deck with optional
 * scrollbar. Targets elements with [data-product-review].
 */

/**
 * @param {HTMLElement} root
 */
function initProductReviewRoot(root) {
  if (!root || root.dataset.productReviewInitialized === 'true') {
    return;
  }
  root.dataset.productReviewInitialized = 'true';

  const useTabs =
    root.getAttribute('data-product-review-use-tabs') === 'true';
  const tabs = root.querySelectorAll('[data-review-tab]');
  const decks = root.querySelectorAll('.product-review__category-deck');

  if (!decks.length) {
    return;
  }

  /**
   * @param {HTMLElement} deck
   * @returns {object | null}
   */
  function initDeckSwiper(deck) {
    if (deck._productReviewSwiper) {
      return deck._productReviewSwiper;
    }
    const el = deck.querySelector('.product-review__swiper');
    if (!el || typeof Swiper === 'undefined') {
      return null;
    }
    const slides = el.querySelectorAll('.swiper-slide');
    if (!slides.length) {
      return null;
    }

    const scrollbarEl = deck.querySelector('.product-review__progress');
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 8,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
      },
    };

    if (scrollbarEl) {
      swiperOptions.scrollbar = {
        el: scrollbarEl,
        draggable: true,
        hide: false,
        snapOnRelease: true,
      };
    }

    const swiper = new Swiper(el, swiperOptions);

    deck._productReviewSwiper = swiper;
    return swiper;
  }

  /**
   * @param {string | null} category
   */
  function setActiveCategory(category) {
    if (!useTabs) {
      return;
    }
    decks.forEach(function (deck) {
      const match = deck.getAttribute('data-review-deck') === category;
      if (match) {
        deck.removeAttribute('hidden');
        const sw = initDeckSwiper(deck);
        if (sw) {
          sw.update();
          sw.slideTo(0, 0);
        }
      } else {
        deck.setAttribute('hidden', '');
      }
    });
  }

  if (useTabs && tabs.length) {
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const cat = tab.getAttribute('data-review-tab');
        tabs.forEach(function (t) {
          const on = t.getAttribute('data-review-tab') === cat;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.classList.toggle('is-active', on);
        });
        setActiveCategory(cat);
      });
    });
  }

  function bootSwipers() {
    if (useTabs && tabs.length) {
      let firstCat = null;
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('aria-selected') === 'true') {
          firstCat = tabs[i].getAttribute('data-review-tab');
          break;
        }
      }
      if (firstCat) {
        setActiveCategory(firstCat);
      }
    } else {
      const single = decks[0];
      if (single) {
        single.removeAttribute('hidden');
        initDeckSwiper(single);
      }
    }
  }

  bootSwipers();
}

function bootAllProductReviews() {
  document.querySelectorAll('[data-product-review]').forEach(initProductReviewRoot);
}

function onReady() {
  bootAllProductReviews();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', onReady);
} else {
  onReady();
}

document.addEventListener('shopify:section:load', function (event) {
  const target = event.target;
  if (!target || typeof target.querySelectorAll !== 'function') {
    return;
  }
  target.querySelectorAll('[data-product-review]').forEach(initProductReviewRoot);
});
